import c_14 from "../../assets/audio-screen/unit14/c_14.mp3"
import c_14_1 from "../../assets/audio-screen/unit14/c_14_1.mp3"


export const audio14 = [
   {
    'text':'Ông Hok: Chào các anh/chỉ, ngày mai chúng ta sẽ có một cuộc họp quan trọng với các đối tác nước ngoài.\nCô Lee: Họ đến từ đan vậy thưa ông?Ông Hok: Họ đến từ tập đoàn lớn, ông Renstaku dến từ Pháp, bà  Michele Đến từ Mỹ, Ông Kim đến từ Hàn Quốc, và các trợ lý viên đi kèm hỗ.\nCô Lee: Khoảng bao nhiêu người tham dự vậy thưa ông?\nÔng Hok: Tôi nghĩ khoảng 20 , cô chuẩn bị chu đáo nhé.\nCô Lee: Vâng thưa ông.\nÔng Hok: Cô có thể được phép ra ngoài rồi sau đó mời anh Đức vào giúp tôi nhé.\nAnh Đức: Xin chào ngài.\nÔng Hok: Mời anh ngồi! Anh có thể ngồi gần bên cạnh tôi, không sao! Như anh đã biết, chúng ta cần phải chuẩn bị nhiều thứ cho cuộc họp. Anh chuyển hết dữ liệu vào trong USB của tôi, máy chiếu phải được treo lên phía trên băng rôn. Mic tự động đặt sẵn bên dưới, ghế lớn để đối diện với sân khấu.\nAnh Đức: Tôi hiểu rồi, thưa ông.\n',
    'audio': c_14,
  },

];

export const audio14_1 = [
    {
      'text':'Lan: Chào Mark và Tony! Tờ rơi vui vì hai bạn đã hạ cánh an toàn. Cậu khỏe không?\nMark và Tony: Tớ hơi mệt một chút, nhưng không sao! Tớ rất vui và cảm ơn cậu vì nhìn thấy cậu đứng bên trong sảnh đợi.\nLan: Cậu khách sáo quá! Nào chúng ta đưa hành lí lên xe đẩy và đi ra ngoài bắt taxi về thành phố nhé.\nTony: Tớ có thể ngồi cạnh cậu được không Lan, còn Sarah sẽ ngồi ở phía trên trước mắt chúng ta và bên cạnh lái xe nhé?\nLan: Tớ đồng ý.\n',
      'audio': c_14_1,
   },
 
 ];